import React from "react";

// Skeleton loaders shown while search-results flights are loading.
const SkeletonBox = ({
  width = "100%",
  height = "1rem",
  className = "",
}: {
  width?: string | number;
  height?: string | number;
  className?: string;
}) => (
  <div
    className={`bg-gray-200 rounded animate-pulse ${className}`}
    style={{ width, height }}
  />
);

export const FlightCardSkeleton = () => (
  <div className="bg-white rounded-lg p-5 border border-gray-200">
    <div className="flex items-center justify-between gap-4 mb-4">
      <div className="flex items-center gap-3">
        <SkeletonBox width="48px" height="48px" className="rounded" />
        <div>
          <SkeletonBox width="60px" height="12px" className="mb-2" />
          <SkeletonBox width="100px" height="14px" />
        </div>
      </div>
      <div>
        <SkeletonBox width="70px" height="12px" className="mb-2" />
        <SkeletonBox width="80px" height="14px" />
      </div>
    </div>
    <div className="bg-lightblue-100 p-4 rounded-lg flex items-center gap-6">
      <div className="flex flex-col items-start gap-1 min-w-[90px]">
        <SkeletonBox width="50px" height="14px" />
        <SkeletonBox width="80px" height="12px" className="mt-1" />
        <SkeletonBox width="70px" height="12px" className="mt-1" />
      </div>
      <div className="flex flex-col items-center w-full">
        <div className="flex items-center w-full">
          <SkeletonBox
            width="12px"
            height="12px"
            className="rounded-full flex-shrink-0"
          />
          <SkeletonBox width="100%" height="2px" className="mx-2" />
          <SkeletonBox width="16px" height="16px" />
          <SkeletonBox width="100%" height="2px" className="mx-2" />
          <SkeletonBox
            width="12px"
            height="12px"
            className="rounded-full flex-shrink-0"
          />
        </div>
        <SkeletonBox width="60px" height="12px" className="mt-1" />
      </div>
      <div className="flex flex-col items-start gap-1 min-w-[90px]">
        <SkeletonBox width="50px" height="14px" />
        <SkeletonBox width="80px" height="12px" className="mt-1" />
        <SkeletonBox width="70px" height="12px" className="mt-1" />
      </div>
    </div>
  </div>
);
